import { DatePipe } from '@angular/common';
import { Component,Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
// import { ToastrService } from 'ngx-toastr';
import { MAT_DATE_FORMATS } from '@angular/material/core';
// import { MatPaginator } from '@angular/material/paginator';
import {MatPaginator, MatSort, MatTableDataSource} from '@angular/material';
// import {MatSort, Sort} from '@angular/material/sort';
// import { MatTableDataSource } from '@angular/material/table';
import { DashboarduiService } from 'src/app/components/Shared/Service/dashboardui.service';
import { LocalstorageService } from 'src/app/components/Shared/Service/localstorage.service';
import { ToastrService } from 'ngx-toastr';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
declare var $: any; 
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


// export class idsProductList {
//   id: any;
//   status: any;
//   // hotelName: any;
//   accountingDate: any;
//   pusheddate: any;
//   type:any
// }

export class idsProductList {
  HotelCode: any;
  HotelName: any;
  HotelCity: any;
  HotelCountry: any;
  lastHeartBeat: any;
  CM: any;
  fxcrs: any;
  others:any;
  id: any;
  status: any;
  // hotelName: any;
  accountingDate: any;
  pusheddate: any;
  type:any
}
@Component({
  selector: 'app-viewhotelsbycm',
  templateUrl: './viewhotelsbycm.component.html',
  styleUrls: ['./viewhotelsbycm.component.css'],
  providers: [DashboarduiService,
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class ViewhotelsbycmComponent {
  // @Input() TechURL:any;
  // @Input() UserURL:any;
  searchText:any;
  typ:any;
  PGF: any = "0";
  PGT: any = "50";
  pageSize = 50;
  isIDSUser: any;
  apiresult: any;
  hotellistChannel: any;
  url: any;
  maxDate: Date;
    pmscode: any;
    hotelName: any;
    islive: any;
    cancelURL: any;
    createURL: any;
    updateURL: any;
    UserId: any;
    flag: any;
    storeDelRec: any;
  storeEventValue: any;
  filterProperty: any;
  totalCount: any;
  errorMsgSubscription: boolean;
  displayContent: boolean;
  countryName: any;
  errorMessage: string;
  channelCodeValue: any;
  btnEnable: boolean= false;
  // private toastr: ToastrService,
  constructor(private toastr: ToastrService,public router:Router,private apiCallIdsService: DashboarduiService, private datePipe: DatePipe, private localStorage: LocalstorageService) { 
    this.maxDate = new Date(this.today.setDate(this.today.getDate()));
  }
  
  today = new Date();
  today1:any= new Date();
  selectedDate: any= new Date(this.today.setDate(this.today.getDate() - 1));
  selectedTOODate: any= new Date(this.today1.setDate(this.today1.getDate() - 1));
  display: Boolean = false;
  hotellistCopy: any = [];
  idsProductList: idsProductList[] = [];
  dataSource!: MatTableDataSource<idsProductList>;
  StorelstRestr: any;
  // lstidsProductList:any;
  // dataSource:any;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  @ViewChild(MatSort, { static: false })
  sort!: MatSort;
  Val: any;
  selectedProperty: any;
  selectedChannel: any;
  isProgressing: Boolean = false;
  public Pmscodevalue: any;
  selected: any;
  Userid: any = [];
  displayedColumns: string[] = ['HotelCode','HotelName','HotelCity','HotelCountry','lastHeartBeat'];

  dropdownSettingsDept: IDropdownSettings = {};
  selectedDeptItems:any;
  dropdownDeptData: any
  ngOnInit() {
    // console.log( this.url)
    this.isProgressing = true;
    // setTimeout(()=>{
      // this.callSyncHotelList();
      this.callChannelsList();
      this.dropdownSettingsDept = {
        idField: 'channelcode',
        textField: 'channelname',
        allowSearchFilter: true,
        singleSelection: true,
        enableCheckAll: false,
        closeDropDownOnSelection: true,
        itemsShowLimit: 7,
        noDataAvailablePlaceholderText: 'No Data Found',
        searchPlaceholderText: "Search Channel Manager"
      };
      this.errorMsgSubscription = true
        this.errorMessage = "Please select Channel and load"
        this.displayContent = false
  }

  callChannelsList(){
    this.apiCallIdsService.getChannelsList()
      .subscribe(
        data => {
          console.log('New Screen Data', data)
          this.apiresult = data;
          this.dropdownDeptData = this.apiresult;
          this.isProgressing = false;
        },
        );
  }

  changePropertySearch() {
    // console.log('selectedDeptItems = ',this.selectedDeptItems)
    if (this.selectedDeptItems) {
      if (this.selectedDeptItems.length > 0) {
        console.log('if condition')
        console.log('selectedDeptItems = ', this.selectedDeptItems)
        this.btnEnable = true
        this.errorMsgSubscription = true
        this.errorMessage = "Please select Channel and load"
        this.displayContent = false
        this.channelCodeValue = this.selectedDeptItems[0].channelcode
        console.log('pms code value = ', this.channelCodeValue)

      } else {
        console.log('Else condition zero')
        this.errorMsgSubscription = true
        this.errorMessage = "Please select Channel and load"
        this.displayContent = false
      }
    } else {
      console.log('Property Not Selected')
      this.btnEnable = false
    }
  }
  
  LoadMethod(){
    this.isProgressing = true;
    this.apiCallIdsService.HotelDataByChannels(this.channelCodeValue)
      .subscribe(
        data => {
          if(data.length > 0){
            this.idsProductList=data;
            this.totalCount = data.length
            this.filterProperty = this.idsProductList
            this.dataSource = new MatTableDataSource(this.idsProductList);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.errorMsgSubscription = false
              this.displayContent = true
            this.toastr.success('Data Loaded Successfully');
            this.isProgressing=false;
          }else {
            this.displayContent = false
            this.errorMsgSubscription = true
            this.errorMessage = "No Data Found"
            this.toastr.error('No Data Found');
            this.isProgressing = false;
          }
        },
        );
  }

  GetParseonlyDateTimeHeartbeat(d:any) {
    var dt1 = new Date(d);
    var dt2 = new Date();
    // console.log('dt1 = ',dt1)
    // console.log('dt2 = ',dt2)
    var diff =(dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    // console.log('Math ABS = ',Math.abs(Math.round(diff)));
    if(Math.abs(Math.round(diff)) > 60){
      return false
    }else{
      return true
    }
      }

  pageEvent(e:any) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  } 
  Search(event:any) {
    console.log('event= ', event)
    this.dataSource = this.filterProperty.filter((res: { hotelname: { toString: () => string; }; pmscustcode: { toString: () => string; };}) => {
      return res.hotelname.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase()) || res.pmscustcode.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase());
    });
    if(event == ''){
      this.Val = '';
    }
  }

  closeModalDialog() {
    this.display = false; //set none css after close dialog
  }
}


